import RequestAbstract from "./RequestAbstract";

export default class PostTasks extends RequestAbstract {
  get link() {
    return this.links.postsTask;
  }

  // Returns per-account publication status for a post created via newPost.
  // Each task carries: status (queued|processing|success|fail), social_type,
  // account_id, published_at, publish_id, and a normalized `result` payload.
  // Poll every 3–5s until no task is in a non-terminal state.
  async getByPost(postId) {
    return await this.get(`${this.link}/by-post/${postId}`);
  }

  // Fetches public TikTok analytics (likes/views/etc) for a published task.
  // Only works for publish_mode=direct tasks in PUBLISH_COMPLETE state.
  async getAnalytics(taskId) {
    return await this.get(`${this.link}/analytics/${taskId}`);
  }

  // Continues a Threads chain that stopped part-way (OP#3466): the task is queued again and the worker skips the
  // parts already live. Silent, because the caller translates the 409 reasons (utils/publishStatus.js
  // describeResumeError) instead of showing the server's English sentence.
  async resumeThread(taskId) {
    return await this.loadWithAuth(
      `${this.link}/resume-thread/${taskId}`,
      { method: "POST", body: JSON.stringify({}) },
      true,
      true,
    );
  }
}
